import { render, staticRenderFns } from "./JournalTemplate.vue?vue&type=template&id=f642888e&scoped=true&"
import script from "./JournalTemplate.vue?vue&type=script&lang=js&"
export * from "./JournalTemplate.vue?vue&type=script&lang=js&"
import style0 from "./JournalTemplate.vue?vue&type=style&index=0&id=f642888e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f642888e",
  null
  
)

export default component.exports